import React from 'react';

const Footer: React.FC = () => {

    return (
        <div className="footer">
            <div>
                <div style={{}} className="footer-block">
                     <a href="https://magiceden.io/marketplace/degenbots_" target="_blank" rel="noreferrer">
                        <img alt="not found" src={"images/melogo.png"} width={30} style={{margin: 5}}/>
                    </a>
                     <a href="https://twitter.com/SKULLBOTS" target="_blank" rel="noreferrer">
                        <img alt="not found" src={"images/twitter.png"} width={30} style={{margin: 5}}/>
                    </a>
                     <a href="https://discord.gg/skullbots" target="_blank" rel="noreferrer">
                        <img alt="not found" src={"images/discord.png"} width={30} style={{margin: 5}}/>
                    </a>                               
                </div>
            </div>
        </div>
    );
};

export default Footer;